module.exports = __webpack_public_path__ + "static/media/54.5b389096.jpg";